<template>
  <div class="general">
    <div class="banner">
      <img src="@/assets/images/general/banner_new.png" alt="" />
    </div>
    <!-- <div class="title">
      <img src="@/assets/images/general/title.png" alt="" />
    </div> -->
    <div class="title">数字教材</div>
    <div class="container nopadding">
      <div class="book_list">
        <div
          class="book_item"
          v-for="(item, index) in newlist"
          :key="index"
          @click="toDetail(item.url)"
        >
          <div class="white">
            <div class="shadow">
              <div class="whites">
                <div
                  class="title_pic"
                  :style="{
                    background: `url(${item.cover})`,
                    backgroundSize: `100% 100%`,
                  }"
                ></div>
              </div>
            </div>
          </div>

          <div class="text">
            <div>主编：{{ item.editor }}</div>
            <div>简介：</div>
            <div class="introduce">
              {{ item.text }}
            </div>
          </div>
          <div class="back"></div>
        </div>
      </div>
    </div>

    <div class="title">数字经济教材</div>
    <div class="container">
      <div class="book_list">
        <div
          class="book_item"
          v-for="(item, index) in bookList"
          :key="index"
          @click="toDetail(item.url)"
        >
          <div class="white">
            <div class="shadow">
              <div class="whites">
                <div
                  class="title_pic"
                  :style="{
                    background: `url(${item.cover})`,
                    backgroundSize: `100% 100%`,
                  }"
                ></div>
              </div>
            </div>
          </div>

          <div class="text">
            <div>主编：{{ item.editor }}</div>
            <div>简介：</div>
            <div class="introduce">
              {{ item.text }}
            </div>
          </div>
          <div class="back"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import cover1 from "../../assets/images/general/back1.png";
import cover2 from "../../assets/images/general/back2.png";
import cover3 from "../../assets/images/general/back3.png";
import cover4 from "../../assets/images/general/back4.png";
import cover5 from "../../assets/images/general/back5.png";
import cover6 from "../../assets/images/general/back6.png";
import cover7 from "../../assets/images/general/back7.png";
import cover8 from "../../assets/images/general/back8.png";
import cover9 from "../../assets/images/general/back9.jpg";

import new1 from "../../assets/images/general/new1.png";
import new2 from "../../assets/images/general/new2.png";
import new3 from "../../assets/images/general/new3.png";
import new4 from "../../assets/images/general/new4.png";
import new5 from "../../assets/images/general/new17.png";
import new6 from "../../assets/images/general/new6.png";
import new7 from "../../assets/images/general/new7.png";
import new8 from "../../assets/images/general/new8.png";
import new9 from "../../assets/images/general/new9.png";
import new10 from "../../assets/images/general/new10.png";
import new11 from "../../assets/images/general/new11.png";
import new12 from "../../assets/images/general/new12.png";
import new13 from "../../assets/images/general/new13.png";
import new14 from "../../assets/images/general/new14.png";
import new15 from "../../assets/images/general/new15.png";
import new16 from "../../assets/images/general/new16.png";

export default {
  data() {
    return {
      bookList: [
        {
          editor: "徐玉发 ",
          cover: cover1,
          text: "人工智能给人类社会和生活带来巨大的改变，作为新时代的大学生都应具备人工智能视野，了解人工智能的应用，并能够运用人工智能技术分析和解决国际贸易的专业问题。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548323821457408",
        },
        {
          editor: "何邓娇",
          cover: cover2,
          text: "本书收集理了大量农业、制造业和服务业的实际应用案例，对云计算应用发展现状进行了详尽的分析，同时对云计算产业政策进行了务实的展望。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877547976461783040",
        },
        {
          editor: "王佳佳",
          cover: cover3,
          text: "近年来，云计算产业快速发展，各个行业都积极投入对云计算技术的应用中，金融行业也不例外。本书可作为金融工程专业本科生的教学用书，亦可供对金融领域云计算应用感兴趣的读者阅读。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548433976463360",
        },
        {
          editor: "徐玉发",
          cover: cover4,
          text: "人工智能应深度赋能城市经济、生活、治理数字化转型，提升城市能级和核心竞争力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877540622135595008",
        },
        {
          editor: "钟二妹 ",
          cover: cover5,
          text: "传统金融模式中，大数据不仅可以根据其不同的数据类型为银行、保险业提供精准营销服务、完善股票的分析方法，还能有效增强金融风险的管控能力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548153864065024",
        },
        {
          editor: "柳翠连",
          cover: cover6,
          text: "本书运用产业经济的主要相关原理，从理论角度进一步深入分析数字经济对国民经济的深刻影响，从宏观和产业视角系统化探索数字经济发展的规律。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548678533746688",
        },
        {
          editor: "杨小金",
          cover: cover7,
          text: "本书系统研究湾区数字经济发展的空间结构理论、产业融合理论和协同创新理论，并结合理论分析国外著名湾区的数字经济发展状况，针对各个湾区的发展特点总结出发展湾区数字经济的思路，",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877548819537858560",
        },
        {
          editor: "杨小金 ",
          cover: cover8,
          text: "本书侧重从经济学的基本理论方面对数字技术及数字经济做较为规范、详细的分析，从而提升学习者对数字经济基本规律、基本现象的理论分析能力，为学习其他数字经济方面的课程打好基础。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877544323814395904",
        },
      ],
      newlist: [
        {
          editor: "魏卫 崔译文 张云侠 ",
          cover: new1,
          text: "《旅游市场营销》全新数字化教材，旨在为旅游管理类或其他管理类本专科学生提供一本既符合新时代要求，又具备高度实用性和前瞻性的权威教材。本教材可作为各类本科院校、高等专科职业技术院校及成人教育培训等相关专业的课程用书，也可作为旅游企业和市场营销从业人员的参考读物。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1900447077385768960&goodsType=looseleafOrtextbook",
        },
        {
          editor: "袁翠翠 ",
          cover: new2,
          text: "教材结合商业银行业务核算特点，以商业银行的主导业务为主线，围绕基本理论，突出实务训练，在总结教学实践经验并借鉴同行业先进经验的基础上编写而成。本教材在编写过程中始终秉承“以学生为中心”的教学理念，结合课程特点、学时要求和学生实际情况，在每章中都设计了对应的练习题,对教学内容进行了较好的整合。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1869975476336988160&goodsType=looseleafOrtextbook",
        },
        {
          editor: "李国玉 ",
          cover: new3,
          text: "Power BI作为一款功能强大的数据分析软件，凭借其高效的数据处理能力和直观的可视化效果，赢得了广泛认可。本书《财务报表分析——Power BI从入门到精通》致力于将财务报表的深厚理论知识与Power BI的数据分析技能相融合，为读者打造一本既具理论深度又富有实践应用的综合性教材。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915236380997455872&goodsType=looseleafOrtextbook",
        },
        {
          editor: "邢莹莹 王沛炼 邓夏 ",
          cover: new4,
          text: "本书从翡翠的起源入手，探讨其形成的地质条件和过程，以及其在地球漫长历史中的演变和分布规律，从而揭示翡翠作为大自然瑰宝的奥秘；随后，深入剖析翡翠的宝石学特征，包括其化学成分、晶体结构、物理性质等，为读者奠定坚实的理论基础；接着介绍合成翡翠及翡翠仿制品的最新研究成果，通过对比分析，帮助读者掌握鉴别真伪的关键技术，提高鉴赏能力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1891691767590424576&goodsType=looseleafOrtextbook",
        },
        {
          editor: "李园 ",
          cover: new5,
          text: "本教材旨在为珠宝设计专业的本科生、相关从业人员、珠宝设计爱好者提供系统、实用的软件学习指南，帮助学生掌握JeweICAD的核心功能、建模规范及其在首饰生产加工中的关键作用。全书内容基于笔者多年的教学与实践经验，结合行业标准，力求在技术操作与设计思维之间建立平衡，使读者不仅能熟练运用软件工具，更能理解数字化设计在珠宝产业链中的实际应用。。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914196857383424000&goodsType=looseleafOrtextbook",
        },
        {
          editor: "梁文峻 梁文思 龚帅 ",
          cover: new6,
          text: "以色彩为研究对象，了解色彩是如何产生、色彩的划分、色彩的基本特征等。从色彩的原理出发，结合人们的认知感受以及实践应用的经验，寻找出色彩变化、搭配和应用的规律，从而能够对艺术设计中的色彩有理性的、全局的认识。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915237830272094208&goodsType=looseleafOrtextbook",
        },
        {
          editor: "文海",
          cover: new7,
          text: "本教材没有像其他的书籍那样分别对人物、静物、风景等进行介绍，这是因为珠宝设计和服装与服饰设计专业的学生绘画基础课时间比较少，他们不能像绘画专业的学生那样去全面地学习绘画基础、只能在有限的时间里掌握绘画的技巧，作者摒弃了部分非必要掌握的知识内容，直接从技法入手，详细分析技法的运用及最后的效果。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914843587703607296&goodsType=looseleafOrtextbook",
        },
        {
          editor: "郭涛",
          cover: new8,
          text: "本教材内容由工具、金属材料与参考信息，工艺与示范、作品欣赏三部分组成，其中基础工艺、金属起版工艺、金属表面处理工艺、特殊工艺等以实践示范图例呈现，由浅至深讲解各项工艺,的特点与技艺要求，从设计、工艺流程及成果展示，强调实践操作中的安全意识，帮助学习者建立起从理论到实践、从设计到制造的系统思维、本教材结合代表性的教学案例与商业实践案例、把材料学、宋石学、美学等诸多理论贯穿干各类设计案例中，重点在于引导与开拓学习者的创意性思维能力。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914192254977839104&goodsType=looseleafOrtextbook",
        },
        {
          editor: "李岩",
          cover: new9,
          text: "在艺术与工艺的浩瀚宇宙中，蜡雕以其独特的魅力和深厚的文化底蕴，历经千年而不衰。作为一名投身蜡雕教学十年的教师，我深感荣幸能够见证并参与这一传统技艺的传承与发展。本书的诞生，正是源于这十年教学经验的沉淀与总结，旨在为初学者和爱好者们提供一份系统、实用且富有启发性的蜡雕学习指南。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1916328535266562048&goodsType=looseleafOrtextbook",
        },
        {
          editor: "荆桦",
          cover: new10,
          text: "Rhinoceros 8（犀牛 8）是由 McNeel & Associates 公司开发的一款专业 3D 建模软件。它具备丰富多样的建模工具，涵盖了 NURBS 曲线、曲面、实体、细分几何图形（SubD）、点云和多边形网格等，能够让用户顺利构建出从简单到复杂的各类三维模型。其基于 NURBS 技术，在建模精度方面表现卓越，可满足不同复杂程度、阶数以及尺寸大小的模型构建要求，无论是机械零件还是珠宝首饰等对精度要求颇高的设计项目都能精准应对",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915279238211178496&goodsType=looseleafOrtextbook",
        },
        {
          editor: "江秋仪",
          cover: new11,
          text: "新能源汽车产业是国家重点发展和大力扶持的产业。由于国家政策的扶持，新能源汽车产业得到飞速的发展，由此带来的新能源汽车后市场将需要大量的销售、维修及其他方面的专业人才。根据目前情况，除了汽车厂家指定的服务站外，综合汽车维修企业接触到的新能源汽车维修业务已经越来越多，汽车维修行业维修技师迫切需要一本体系化的新能源汽车专业书籍，以满足汽车维修技师学习和行业培训的需求。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915294941916041216&goodsType=looseleafOrtextbook",
        },
        {
          editor: "张春花",
          cover: new12,
          text: "一本专注于汽车电气系统和电子设备的专业书籍，主要面向汽车工程、车辆工程、电气工程等相关专业的学生、教师以及汽车行业的工程技术人员。该书系统地介绍了现代汽车中各种电器与电子设备的基本原理、结构、功能及其应用，涵盖了从传统汽车电气系统到现代智能汽车电子技术的广泛内容。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915308070452465664&goodsType=looseleafOrtextbook",
        },
        {
          editor: "马海霞",
          cover: new13,
          text: "一本专注于反激式开关电源技术的专业书籍，主要面向电力电子、电气工程、自动化等相关领域的学生、研究人员以及从事电源设计与开发的工程技术人员。该书系统地介绍了反激式开关电源的基本原理、设计方法、关键元器件选型、控制策略以及实际应用，涵盖了从基础理论到工程实践的全面内容。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915319766151729152&goodsType=looseleafOrtextbook",
        },
        {
          editor: "沈剑文 乔世燕 邝曦妮",
          cover: new14,
          text: "我们认为，“译机融合”是一种翻译操作模式，指的是在翻译过程中，充分发挥机器翻译与人工翻译各自的优势，利用技术手段提升翻译质量、提高翻译效率。“译机融合”强调机器与人工的协同作用，译者首先通过机器处理大量源语言（source language，ST）文本，快速生成目的语（target language，TL）文本初稿，再由人进行细致的编辑和校对，从而实现翻译的准确性和自然性。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1914188486613798912&goodsType=looseleafOrtextbook",
        },
        {
          editor: "董 艺  胡慧芸  李 虹",
          cover: new15,
          text: "本书涵盖了机械制图基本理论和软件操作两大部分内容，由基于AutoCAD软件保护的二维图绘制、基于Sloidworks软件的三维建模、基于Sloidworks软件的装配、基于Sloidworks软件的工程图绘制、减速箱的建模与装配等5个项目组成。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1915323026329702400&goodsType=looseleafOrtextbook",
        },
        {
          editor: "王磊 冯慧雅 万慧兰",
          cover: new16,
          text: "全书包含七个项目，深入浅出地介绍了人工智能技术的整体框架和应用场景，并探讨了人工智能技术、人工智能的实践研究、智能机器人、人工智能伦理等内容。我们在编写本书时考虑了通识性和综合性两方面，在每个项目开篇都给出了相应的导读案例，逐步引出主题内容，力求以技术渗透讲解、以应用实例加深理解。在每个项目末尾设置了习题，帮助读者进一步加深理解。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1913074559070900224&goodsType=looseleafOrtextbook",
        },
        {
          editor: "高震 郝琦 ",
          cover: cover9,
          text: "CorelDRAW 软件是一款“亲民”的设计软件，由于其运行速度快、操作简便、绘图功能强大，自问世以来就受到设计师们的青睐。",
          url: "https://web.ysy.crtvup.com.cn/#/bookstore/bookstoreDetail?goodsId=1877516845351833600",
        },
      ],
    };
  },
  created() {},
  methods: {
    toDetail(id) {
      if (id) {
        window.open(id, "_blank");
      }
    },
  },
};
</script>
  <style lang='scss' scoped>
.general {
  background-color: #ffffff;
}
.banner {
  margin-bottom: 55px;
}
.title {
  text-align: center;
  margin-bottom: 12px;
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 24px;
  color: #2d2d2d;
  line-height: 28px;
  img {
    // width: 180px;
    height: 16px;
  }
}
.container {
  width: 1400px;
  margin: 52px auto 0;
  padding-bottom: 75px;
  .book_list {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .book_item {
      cursor: pointer;
      width: 430px;
      height: 234px;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 65px;
      position: relative;
      background-color: #fcfcfc;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: calc((100% - 1260px) / 3);
      .back {
        width: 84px;
        height: 88px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: url("../../assets/images/general/item_back.png") no-repeat;
        background-size: 100% 100%;
        opacity: 0.2;
      }

      .text {
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-right: 24px;
        margin-top: -20px;
        width: 203px;
        height: calc(100% - 16px);
        // padding: 8px 0;
        .introduce {
          text-indent: 2em;
          height: calc(100% - 48px);
          overflow-y: auto;
        }
      }
      .white {
        width: 172px;
        height: 231px;
        transform-origin: left bottom;
        // background: url("../../assets/images/general/bg.png");
        background: #ffffff;
        box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
        position: absolute;
        left: 0px;
        top: -10px;
        transition: transform 0.5s ease-in-out;
        transform: rotateZ(0deg);
        .shadow {
          position: absolute;
          top: 0;
          left: 0;
          width: 172px;
          height: 231px;
          transform-origin: left bottom;
          transition: transform 0.5s ease-in-out;
          background: rgb(180, 176, 176);
          .whites {
            width: 172px;
            height: 231px;
            transform-origin: left bottom;
            transition: transform 0.5s ease-in-out;
            background: #ffffff;
            .title_pic {
              // position: absolute;
              width: 172px;
              height: 231px;
              box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);
              transition: transform 0.5s ease-in-out;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .book_item:nth-child(3n){
      margin-right: 0;
    }
    // .book_item {
    //   box-shadow: 0 2px 5px rgba(136, 136, 136, 0.3);

    //   .white {
    //     transform-origin: left bottom;
    //     transform: rotateZ(-2deg) translateX(12px);
    //     .shadow {
    //       transform-origin: left bottom;
    //       transform: rotateZ(0deg) translateX(-4px);
    //       .whites {
    //         transform-origin: left bottom;
    //         transform: rotateZ(0deg) translateX(-4px);
    //         .title_pic {
    //           transform-origin: left bottom;
    //           transform: rotateZ(-0deg) translateX(-4px);
    //         }
    //       }
    //     }
    //   }
    // }
  }
}
.nopadding {
  padding-bottom: 0;
}
</style>